import { QrScanner } from '@yudiel/react-qr-scanner';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import "./scanner.css"
import { formatDate } from '../utils/helpers';

const Scanner = () => {

  const [result, setResult] = useState(null)
  const [error, setError] = useState(null)
  const [attachment, setAttachment] = useState(null)

  const [existing, setExisting] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      if (result) {
        try {
          const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/get-attachments?code=${result}`);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          setExisting(data); // Assuming the response is an array of attachments
          toast.success("Attachments loaded successfully");
        } catch (error) {
          console.error('Error:', error);
          toast.error("No Attachments found. Add new!");
        }
      }
    };

    fetchData();
  }, [result]);

  const handleFile = (e) => {
    setAttachment(e.target.files[0]); // Capture the file
  };

  const renderAttachment = (attachment) => {
    const isVideo = attachment.url.match(/\.(mp4|webm)$/i);
    return (
      <div key={attachment.id} className="attachment-card">
        {isVideo ? (
          <video controls src={attachment.url} />
        ) : (
          <img src={attachment.url} alt={`Attachment ${attachment.id}`} />
        )}
        <p><strong>Created On :</strong>{formatDate(attachment.created_at)}</p>
        <p><strong>Longitude :</strong>{attachment.longitude}</p>
        <p><strong>Latitude :</strong>{attachment.latitude}</p>
      </div>
    );
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append('attachment', attachment);
    formData.append('code', result); // Assuming 'result' is your code

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        formData.append('latitude', position.coords.latitude);
        formData.append('longitude', position.coords.longitude);

        // Rest of the fetch request as before
        try {
          const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/save-attachment`, {
            method: 'POST',
            body: formData,
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const result = await response.json();
          if (result && result.data) {
            setExisting(result.data)
            toast.success("Success: " + result.message)
          }

        } catch (error) {
          console.error('Error:', error);
          // Handle errors
        }
      }, (error) => {
        console.error('Error getting location:', error);
        // Handle location error
      });
    } else {
      console.log('Geolocation is not supported by this browser.');
      // Handle case where geolocation is not supported
    }
  };

  const btnSTyles = {
    border: "0px",
    borderRadius: "5px",
    padding: "10px",
    outline: "none",
    cursor: "pointer",
    marginTop: "30px",
    marginBottom: "30px"
  }
  return (
    <div>
      <QrScanner
        onDecode={(result) => setResult(result)}
        onError={(error) => setError(error?.message)}
      />
      {
        error &&
        <p>{error}</p>
      }
      {
        result && !error &&
        <div>
          <p><strong>Code:</strong> <span>{result}</span></p>
          {
            existing && existing.length > 0 &&
            <>
              <h4>Already Attached files to this code</h4>
              <div className='attachments'>
                {existing.map(renderAttachment)}
              </div>
            </>
          }

          <div>
            <input type="file" placeholder="Select image/video file" onChange={handleFile} />
            <div>
              <button style={btnSTyles} onClick={handleSubmit}>Attach File</button>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default Scanner